import { FormControl, Paper } from "@mui/material";

import cardStyles from "./CondensedReportView.module.scss";
import styles from "./CrimeCodesCard.module.scss";
import CrimeCodeSelector from "./CrimeCodeSelector";

export interface CrimeCodesCardProps {
  orgId: string;
  submissionId: string;
  surveyClass: string;
  enabled: boolean;
  readOnly?: boolean;
  required?: boolean;
  onCodesChange?: (count: number) => void;
}

/**
 * Card wrapper for the crime-codes multi-select on the condensed report. Shares
 * the officer-card container and content inset used by ReviewerDetails and
 * EmailNotesCard, but has no header. Renders nothing when crime codes are off.
 */
const CrimeCodesCard = ({ enabled, ...selectorProps }: CrimeCodesCardProps) => {
  if (!enabled) return null;

  return (
    <Paper elevation={3} className={cardStyles.paperOfficerDetailsContainer}>
      <div className={styles.body}>
        <FormControl fullWidth>
          <CrimeCodeSelector enabled={enabled} {...selectorProps} />
        </FormControl>
      </div>
    </Paper>
  );
};

export default CrimeCodesCard;
